import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  location: string;
  content: string;
  age: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  content,
  age
}: TestimonialCardProps) {
  return <div className="bg-[#FFF8E7] p-6 rounded-sm border border-[#8B4513]/30 shadow-md relative group hover:shadow-lg transition-shadow duration-300" data-id="element-19">
      {/* Decorative corner */}
      <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-[#7C2D2D] rounded-tr-sm opacity-50" data-id="element-20"></div>
      <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-[#7C2D2D] rounded-bl-sm opacity-50" data-id="element-21"></div>

      <Quote className="w-8 h-8 text-[#8B4513] opacity-20 mb-4" data-id="element-22" />

      <p className="font-serif text-lg text-[#2D241E] italic mb-6 leading-relaxed" data-id="element-23">
        "{content}"
      </p>

      <div className="border-t border-[#8B4513]/20 pt-4" data-id="element-24">
        <h4 className="font-serif font-bold text-[#7C2D2D] text-lg" data-id="element-25">{name}</h4>
        <div className="flex flex-col sm:flex-row sm:items-center text-sm font-sans text-[#5D4037] mt-1 gap-1 sm:gap-2" data-id="element-26">
          <span data-id="element-27">{age}</span>
          <span className="hidden sm:inline text-[#8B4513]" data-id="element-28">•</span>
          <span data-id="element-29">{role}</span>
          <span className="hidden sm:inline text-[#8B4513]" data-id="element-30">•</span>
          <span className="font-medium" data-id="element-31">{location}</span>
        </div>
      </div>
    </div>;
}